<script>
	import { createEventDispatcher } from "svelte";
	import { isVideoFile } from "src/utils/misc";
	import {
		imageLightbox,
		imageLightboxIndex,
		isLightBoxOpen,
	} from "src/store/store";

	export let files = [];

	const dispatch = createEventDispatcher();

	function openLightbox(index) {
		const urls = files.filter((f) => f.status === "done").map((f) => f.url);
		imageLightbox.set(urls);
		imageLightboxIndex.set(urls.indexOf(files[index].url));
		isLightBoxOpen.set(true);
	}
</script>

<div class="media-list">
	{#each files as { file, url, status, progress }, i}
		<div class="media-item">
			<button
				class="delete-icon"
				type="button"
				on:click={() => dispatch("remove", { index: i })}
			>
				<span class="sr-only">Remove</span>
			</button>
			{#if status === "done"}
				<button
					type="button"
					class="open-btn"
					on:click={() => openLightbox(i)}
				>
					<span class="sr-only">Preview {file?.name ?? "media"}</span>
					{#if isVideoFile(url)}
						<video
							src={`${url}#t=0.1`}
							class="thumbnail"
							preload="metadata"
							muted
						>
							<track kind="captions" label="Captions" />
						</video>
					{:else}
						<img src={url} alt="" class="thumbnail" />
					{/if}
				</button>
			{:else}
				<div class="thumbnail placeholder" />
			{/if}
			{#if status === "uploading"}
				<span class="overlay">{Math.round((progress ?? 0) * 100)}%</span
				>
			{:else if status === "error"}
				<button
					class="overlay error"
					type="button"
					title="Upload failed. Click to retry"
					on:click={() => dispatch("retry", { index: i })}
					>Retry</button
				>
			{/if}
		</div>
	{/each}
</div>

<style>
	.media-list {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
	}

	.media-item {
		position: relative;
		width: 56px;
		height: 56px;
	}

	.sr-only {
		position: absolute;
		width: 1px;
		height: 1px;
		overflow: hidden;
		clip: rect(0 0 0 0);
		white-space: nowrap;
	}

	.thumbnail {
		width: 100%;
		height: 100%;
		object-fit: cover;
		background: var(--fds-surface-variant, #eee);
	}

	.open-btn {
		display: block;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		background: none;
		cursor: pointer;
	}

	.overlay {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.55);
		color: white;
		font-size: 11px;
		border: none;
		padding: 0;
	}

	.overlay.error {
		background: rgba(214, 12, 12, 0.8);
		cursor: pointer;
	}

	.delete-icon {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 24px;
		height: 24px;
		background: url("/assets/icon-cancel-circle.svg") center / cover;
		border: none;
		z-index: 2;
		cursor: pointer;
	}
</style>
